import React from 'react';
import { Button } from '../../components/ui/button';
import { Loader2, ListChecks, Check, Copy, Zap } from 'lucide-react';

export const CopilotActionPlan = ({ EXECUTABLE, copyText, doneIds, plan, planLoading, runAction, runningId, suggestPlan, typeLabels }) => (
        <div>
          <Button onClick={suggestPlan} disabled={planLoading} variant="outline" className="w-full text-sm">
            {planLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <ListChecks className="w-4 h-4 mr-2" />}
            Suggest action plan (propose &rarr; you approve &rarr; run)
          </Button>
          {plan && (
            <div className="mt-3 space-y-2">
              {plan.summary && <p className="text-xs text-slate-600 dark:text-slate-400 italic">{plan.summary}</p>}
              {(plan.proposed_actions || []).map((a) => {
                const executable = EXECUTABLE.includes(a.type);
                const done = doneIds[a.id];
                return (
                  <div key={a.id} className="rounded-lg border border-slate-200 dark:border-slate-700 p-3">
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <div className="flex items-center gap-2">
                        <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300">
                          {typeLabels[a.type] || a.type}
                        </span>
                        <span className="text-sm font-medium text-slate-900 dark:text-slate-100">{a.title}</span>
                      </div>
                      {done ? (
                        <span className="flex items-center gap-1 text-xs text-emerald-600"><Check className="w-3.5 h-3.5" />{done}</span>
                      ) : executable ? (
                        <Button onClick={() => runAction(a)} disabled={runningId === a.id}
                          className="h-7 text-xs bg-amber-600 hover:bg-amber-700 text-white">
                          {runningId === a.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Zap className="w-3.5 h-3.5 mr-1" />Approve &amp; run</>}
                        </Button>
                      ) : a.content ? (
                        <Button onClick={() => copyText(a.content)} variant="outline" className="h-7 text-xs">
                          <Copy className="w-3.5 h-3.5 mr-1" />Copy
                        </Button>
                      ) : null}
                    </div>
                    {a.rationale && <p className="text-[11px] text-slate-500 mb-1">{a.rationale}</p>}
                    {a.content && (
                      <div className="text-xs text-slate-600 dark:text-slate-300 bg-slate-50 dark:bg-slate-800/60 rounded p-2 whitespace-pre-wrap">{a.content}</div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
);
